import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { CustomerService } from 'src/app/services/customer.service';
declare var $: any;

@Component({
  selector: 'app-least-valuable-members',
  templateUrl: './least-valuable-members.component.html',
  styleUrls: ['./least-valuable-members.component.css'],
})
export class LeastValuableMembersComponent implements OnInit {
  userList: any[] = [];
  p: number = 1;
  total: number = 0;
  count: number = 0;
  itemsPerPage: number = 20;
  baseUrl = environment.baseUrl;
  selectedUserIds: Set<number> = new Set();
  isAllSelected: boolean = false;


  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private router: Router,
    private customerService: CustomerService,
  ) { }

  // Export properties
  availableExportFields = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Username' },
    { key: 'email', label: 'Email Address' },
    { key: 'countryCode', label: 'Country Code' },
    { key: 'phone', label: 'Phone Number' },
    { key: 'gender', label: 'Gender' },
    { key: 'dateOfBirth', label: 'dateOfBirth' },
    { key: 'occupation', label: 'occupation' },
    { key: 'nationality', label: 'Nationality' },
    { key: 'activity_score', label: 'activity_score' },
    { key: 'attractiveness_score', label: 'attractiveness_score' },
    { key: 'likes_received', label: 'likes_received' },
    { key: 'passes_received', label: 'passes_received' },
    { key: 'likes_sent', label: 'likes_sent' },
  ];

  selectedExportFields: string[] = [
    'id',
    'name',
    'email',
    'countryCode',
    'phone',
    'gender',
    'dateOfBirth',
    'occupation',
    'nationality',
    'activity_score',
    'attractiveness_score',
    'likes_received',
    'passes_received',
    'likes_sent',
  ];

  ngOnInit(): void {
    this.getUsers(this.p);
  }

  getUsers(page: number) {
    const token = localStorage.getItem('token');
    // Using accessToken header as per Service pattern
    const headers = new HttpHeaders().set('accessToken', token || '');

    // pagination works like this: ?page=2
    const url = `${this.baseUrl}/getLeastValuableMembers?page=${page}`;

    this.http.get(url, { headers }).subscribe(
      (res: any) => {
        if (res) {
          // Response structure based on request:
          // { "users": [...], "pagination": { ... } }

          if (res.users) {
            this.userList = res.users;
          } else if (res.data && res.data.users) {
            // Fallback just in case response is wrapped in data
            this.userList = res.data.users;
          } else {
            this.userList = [];
          }

          if (res.pagination) {
            this.p = res.pagination.page || page;
            this.itemsPerPage = res.pagination.limit || 20;
            this.total = res.pagination.total || 0;
          } else if (res.data && res.data.pagination) {
            this.p = res.data.pagination.page || page;
            this.itemsPerPage = res.data.pagination.limit || 20;
            this.total = res.data.pagination.total || 0;
          }
        } else {
          this.toastr.error('Failed to fetch data');
        }
      },
      (err) => {
        this.toastr.error('Error fetching data');
        console.error(err);
      }
    );
  }

  onPageChange(page: number) {
    this.p = page;
    this.getUsers(page);
  }

  goToCustomerDetail(userId: string | number) {
    // redirect on customer-detail/{id}/approved
    this.router.navigate([`/customer-detail/${userId}/approved`]);
  }

  calculateAge(dob: string | Date): string | number {
    if (!dob) return '';
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  toggleSelection(userId: number) {
    if (this.selectedUserIds.has(userId)) {
      this.selectedUserIds.delete(userId);
    } else {
      this.selectedUserIds.add(userId);
    }
    this.updateSelectAllState();
  }

  toggleAllSelection() {
    this.isAllSelected = !this.isAllSelected;
    if (this.isAllSelected) {
      this.userList.forEach((user) => this.selectedUserIds.add(user.user_id));
    } else {
      this.selectedUserIds.clear();
    }
  }

  updateSelectAllState() {
    this.isAllSelected =
      this.userList.length > 0 &&
      this.userList.every((user) => this.selectedUserIds.has(user.user_id));
  }

  confirmArchive() {
    // Logic handled by modal trigger in HTML, this might just set a flag if needed or be empty
    // But since we use bootstrap modal, we just need the bulkArchiveUsers method correctly called
  }

  bulkArchiveUsers() {
    if (this.selectedUserIds.size === 0) return;

    const token = localStorage.getItem('token');
    const headers = new HttpHeaders().set('accessToken', token || '');
    const body = { user_ids: Array.from(this.selectedUserIds) };

    this.http
      .post(`${this.baseUrl}/bulkArchiveUsers`, body, { headers })
      .subscribe(
        (res: any) => {
          if (res && res.status === 200) {
            this.toastr.success('Users archived successfully');
            this.selectedUserIds.clear();
            this.isAllSelected = false;
            this.getUsers(this.p); // Refresh list
            // Close modal programmatically if needed, or rely on data-dismiss
            // Assuming we need to manually hide it or it auto-hides on button click if configured
            document.getElementById('closeArchiveModal')?.click();
          } else {
            this.toastr.error(res.message || 'Failed to archive users');
          }
        },
        (err) => {
          this.toastr.error('Error archiving users');
          console.error(err);
        }
      );
  }

  // Export modal methods
  openExportModal() {
    $('#exportModal').modal('show');
  }

  toggleExportField(fieldKey: string) {
    const index = this.selectedExportFields.indexOf(fieldKey);
    if (index > -1) {
      this.selectedExportFields.splice(index, 1);
    } else {
      this.selectedExportFields.push(fieldKey);
    }
  }

  selectAllExportFields() {
    this.selectedExportFields = this.availableExportFields.map(
      (field) => field.key
    );
  }

  clearAllExportFields() {
    this.selectedExportFields = [];
  }

  exportWithSelectedFields() {
    if (this.selectedExportFields.length === 0) {
      this.toastr.error('Please select at least one field to export');
      return;
    }

    if (
      confirm(
        'Are you sure you want to export these Customers with the selected fields?'
      )
    ) {

      const token = localStorage.getItem('token');
      const headers = new HttpHeaders().set('accessToken', token || '');

      let obj = {
        page: 0,
        isExport: true,
        exportFields: this.selectedExportFields, // Pass selected fields to backend
      };

      this.customerService
        .getLeastValuableMembers(obj, token)
        .subscribe((res: any) => {
          // Assume the backend returns the file blob for export
          const blob = window.URL.createObjectURL(
            new Blob([res], { type: 'application/xlsx' })
          );
          var downloadURL = window.URL.createObjectURL(res);
          var link = document.createElement('a');
          link.href = downloadURL;
          link.setAttribute('download', 'Export Report.xlsx');
          link.click();

          // Close the modal
          $('#exportModal').modal('hide');
        });
    }
  }

}


